module.exports = __webpack_public_path__ + "img/up.52afa34c.svg";